import * as React from "react"
import { Skeleton } from "@mui/material"
import { AppTableSeeker } from "@components"

import { GROUPED_BY } from "@constants"
import { useSkuDetailsReviewsData } from "./@hooks"
import SkuDetailsReviewsTableActions from "./Actions"
import { countryColumn, lastReviewColumn, lastReviewRatingColumn, numOpinionsColumn, ratingColumn, retailerColumn } from "./columns"


export default function SkuDetailsReviewsTable() {
	
	const { isLoadingReviews, data, handleChangeGroupBy, reviewsGroupBy, optionSelected } = useSkuDetailsReviewsData()
	
	if (isLoadingReviews) return <Skeleton variant="rectangular" height={300} />
    if (!data?.length) return <></>

	return <AppTableSeeker
		title="Sentiment"
		data={data}
		columns={[
            ...countryColumn(),
            ...(reviewsGroupBy.includes(GROUPED_BY.RETAILER) ? [retailerColumn()] : []),
			lastReviewColumn(),
			numOpinionsColumn(),
			ratingColumn(),
			lastReviewRatingColumn()
		]}
		options={{
			rowsPerPage: 5,
			rowsPerPageOptions: [5, 10],
			tableBodyHeight: '365px',
			customToolbar: () => {
				return <SkuDetailsReviewsTableActions handleChangeGroupBy={handleChangeGroupBy} optionSelected={optionSelected} />
			}
		}}
	/>
}